import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { 
  Calendar,
  Award,
  GraduationCap,
  MapPin
} from "lucide-react";

const BOOKING_URL = "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ2sLR40fV8O-hfoDyzVRQq1wTbDNf0T-8Ovy79yBcvaGSRyMCmuzMMj_fEnqs6AjhDQlKyeVbLd";

const AboutPage = () => {
  const credentials = [
    { icon: <GraduationCap className="w-5 h-5" />, text: "Master's in Nutrition & Integrative Health, MUIH" },
    { icon: <Award className="w-5 h-5" />, text: "Certified Holistic Doula, The Matrona" },
    { icon: <Award className="w-5 h-5" />, text: "Certified Community Doula, Coco Life Black" },
    { icon: <GraduationCap className="w-5 h-5" />, text: "Registered Yoga Teacher (RYT 200)" },
    { icon: <Award className="w-5 h-5" />, text: "Private Chef, USPCA Member" },
    { icon: <GraduationCap className="w-5 h-5" />, text: "Urban Farming Certificate, ECO CITY FARMS" },
  ];

  return (
    <div className="min-h-screen bg-warm-white pt-24">
      {/* Hero */}
      <section className="py-12 md:py-20 bg-gradient-to-br from-peach/40 to-clay/40">
        <div className="max-w-5xl mx-auto px-5 sm:px-6 md:px-12">
          <div className="grid md:grid-cols-2 gap-8 md:gap-14 items-center">
            {/* Image */}
            <div className="relative flex justify-center">
              <div className="rounded-3xl overflow-hidden shadow-xl max-w-sm md:max-w-md">
                <img
                  src="https://customer-assets-eiarnc6j.emergentagent.net/job_1e730d40-55a8-4421-8dbe-a02d71b76db0/artifacts/5r56zdci_Trina%20Cobbler%20People%27s%20Medicine%20Wellness.webp"
                  alt="Trina Cobbler - Certified Holistic Doula"
                  className="w-full h-auto object-cover object-top"
                />
              </div>
            </div>

            {/* Content */}
            <div className="space-y-6">
              <p className="text-xs sm:text-sm uppercase tracking-widest text-teal font-body font-bold">
                Meet Your Doula
              </p>
              <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl font-medium text-plum">
                Hi, I'm Trina
              </h1>
              <div className="space-y-4 font-body text-plum/80 leading-relaxed">
                <p>
                  I became a doula because I believe women deserve care from the very beginning. I've seen how much support is missing for women during pregnancy and postpartum, and I feel called to fill that gap.
                </p>
                <p>
                  My journey started when I became obsessed with health and wellness while working in the hospitality industry. I was overworked, undernourished, and unhappy. That experience led me to develop a set of lifestyle skills focused on spiritual empowerment, healthy personal care, and consistent positive habits.
                </p>
                <p>
                  Now, my mission is to provide high-quality, culturally informed care to women and their children guiding them through one of the most vulnerable and transformative times in their lives.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Credentials */}
      <section className="py-12 md:py-20 bg-white">
        <div className="max-w-3xl mx-auto px-5 sm:px-6 md:px-12">
          <h2 className="font-heading text-2xl sm:text-3xl md:text-4xl font-medium text-plum mb-8 text-center">
            Credentials & Training
          </h2>
          <div className="bg-gradient-to-br from-peach/30 to-clay/30 rounded-3xl p-6 md:p-10">
            <div className="grid sm:grid-cols-2 gap-4">
              {credentials.map((cred, index) => (
                <div key={index} className="flex items-start gap-3 text-plum/80">
                  <span className="text-teal mt-0.5">{cred.icon}</span>
                  <span className="font-body text-sm">{cred.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Service Area */}
      <section className="py-12 md:py-20 bg-gradient-to-br from-peach/20 to-clay/20">
        <div className="max-w-3xl mx-auto px-5 sm:px-6 md:px-12 text-center">
          <MapPin className="w-10 h-10 text-teal mx-auto mb-4" />
          <h2 className="font-heading text-2xl sm:text-3xl font-medium text-plum mb-4">
            Where I Serve
          </h2>
          <p className="font-body text-plum/70 leading-relaxed mb-4">
            I provide virtual, phone, and in-person support to families across America. In-person services are available throughout all 23 counties of Maryland, the DMV area, and I'm willing to travel contact me for more info.
          </p>
          <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer">
            <Button 
              data-testid="about-book-btn"
              className="bg-teal hover:bg-teal-dark text-white rounded-full px-8 py-5 text-base mt-4"
            >
              <Calendar className="w-5 h-5 mr-2" />
              Schedule a Support Call
            </Button>
          </a>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
